import {
  AutocompleteRenderInputParams,
  Box,
  CircularProgress,
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import React from 'react';
import { ContactSearchAutocomplete } from './ContactSearchAutocomplete.styles';
import { ContactSearchBackButton } from './ContactSearchBackButton.styles';
import { ContactSearchField } from './ContactSearchField.styles';
import { useContactsSearchController } from '../../controllers';
import { ContactsSearchContact, ContactsSearchProps } from '../../types';
import ContactConsentModal from '../ContactConsentModal';

const ContactsSearch = (props: ContactsSearchProps) => {
  const {
    searchInputRef,
    hideHeader,
    search,
    contacts,
    isContactsLoading,
    isCreatingContact,
    shouldShowDropdown,
    showConsentModal,
    handleConsentModalClose,
    createNewContact,
    handleSearchInputChange,
    handleContactChange,
    filterContactOptions,
    handleSearchKeyDown,
  } = useContactsSearchController(props);

  const { isMobile, onBackToList } = props;

  if (hideHeader) {
    return <Box height={120} />;
  }

  return (
    <>
      <ContactConsentModal
        open={showConsentModal}
        onClose={handleConsentModalClose}
        onConfirm={createNewContact}
      />
      <ContactSearchAutocomplete
        disablePortal
        freeSolo
        open={shouldShowDropdown && !isCreatingContact}
        inputValue={search || ''}
        onInputChange={handleSearchInputChange}
        onChange={handleContactChange}
        disabled={isContactsLoading === undefined || isCreatingContact}
        id="constacts-search"
        options={contacts || []}
        getOptionLabel={option => {
          if (typeof option === 'string') {
            return option;
          }
          if (option.phoneNumber) {
            return option.phoneNumber;
          }
          return option.phoneNumber;
        }}
        renderOption={(liProps, option) => {
          if (typeof option === 'string') {
            return (
              <li {...liProps} key={option}>
                {option}
              </li>
            );
          }
          return (
            <li {...liProps} key={option.phoneNumber}>
              {option.firstName || ''} {option.lastName || ''} {option.phoneNumber}
            </li>
          );
        }}
        filterOptions={(options, params) =>
          filterContactOptions(options as ContactsSearchContact[], params)
        }
        renderInput={(params: AutocompleteRenderInputParams) => (
          <ContactSearchField
            {...params}
            inputRef={searchInputRef}
            placeholder="Search Contacts..."
            variant="standard"
            onKeyDown={handleSearchKeyDown}
            InputProps={{
              disableUnderline: true,
              ...params.InputProps,
              startAdornment: (
                <Box p={1} display="flex" alignItems="center">
                  {isMobile && onBackToList && (
                    <ContactSearchBackButton aria-label="Back to conversations" onClick={onBackToList}>
                      <KeyboardBackspaceIcon />
                    </ContactSearchBackButton>
                  )}
                  To:
                </Box>
              ),
              endAdornment: (
                <React.Fragment>
                  {isContactsLoading || isCreatingContact ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export default ContactsSearch;
